export default __webpack_public_path__ + "static/media/sponsored-ads.cda76a70.jpg";